// extracted by mini-css-extract-plugin
export default {"UserSummary":"fkoWPU30Nepn+H7CNRGAJQ=="};